import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import CaptaincyService from "@services/CaptaincyService";

const ShowCaptaincy = ({ captaincy }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [captaincyData, setCaptaincyData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (showModal)
      CaptaincyService.find(captaincy.id).then((response) => {
        setCaptaincyData(response.data.data);
      });
  }, [captaincy.id, showModal]);

  return (
    <PermissionHandler permission={"view_captaincies"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={captaincyData.name} />
          <RowDetails label={t("nameEng")} value={captaincyData.name_eng} />
          <RowDetails
            label={t("description")}
            value={captaincyData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowCaptaincy;
